import { render, staticRenderFns } from "./InventoryLockedTable.vue?vue&type=template&id=57f42b31"
import script from "./InventoryLockedTable.vue?vue&type=script&lang=js"
export * from "./InventoryLockedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports